<template>	
	<basic-header
        pretitle="aqfer Universal Tag"
        title="Configure Hosts"
        buttonText="Add Entry"
		:buttonRoles= "btnRoles"
        @btnClick="showModal({ component: 'addEdgeHost' })"
    />
	<div class="container-fluid">		
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<datatable
						tableId="hostList"
						:columns="columns"
						uniqueField="edgeHostname"
						:data="domainList"
						:compact="true"
						:detailColumn="{
							baseUrl: 'configure-hosts/',
							name: 'Configure CNames',
							identifier: 'edgeHostname',
							identifierName: 'hostName'
						}"
					/>
				</div>
			</div>
		</div>
	</div>	
</template>

<script>
	import BasicHeader from '../../components/BasicHeader.vue';
	import Datatable from "../../components/Datatable.vue";
	import { mapActions } from "vuex";
	export default {
		components: { Datatable , BasicHeader},
		data() {
			return {
				columns: [
					{ data: "edgeHostname" },
					{
						data: "domains",
						render: function (data, type, row) {
							if (!data) return "";
							return Array.isArray(data.items)
								? data.items.length
								: 0;
						},
					},
					{
						data: "ipType",
						render: function(data, type, row) {
							return data == "DUAL" ? "IPV4, IPV6" : "IPV4" ;
						}
					},
					{
						title: "certificate name",
						render: function(data, type, row) {
							if (row.certificateType == "THIRD-PARTY") {
								return row.certificate?.commonName ? row.certificate.commonName : null;
							}
						}
					}
				],
				btnRoles: [1, 1.5],
				domainList: [],
				certificates: [],
			};
		},
		async beforeMount() {
			// await this.fetchDomainList();
			await this.fetchCertificatesList();
			await this.fetchDomainList();
		},
		computed: {
			userRoleRank() {
				return this.$store.getters.userRoles.userRoleRank;
			}  
		},  
		methods: {
			...mapActions({
				showModal: "showModal",
				fetchCertificates: "aut/fetchCertificates",
				getDomainLists: "aut/getDomainLists"
			}),
			async fetchDomainList() {
				await this.getDomainLists().then((response) => {
					let domainList = response.data
					if (!domainList) return
					domainList.forEach(item => {
						if (item.certificateType == "THIRD-PARTY") {
							item.certificate = this.certificates.find(certificate => certificate.id == item.certificateName)
						}
					})
					this.domainList = domainList
				}).catch(err => {
					console.error(err)
					let error = err.response ? err.response.data.error : err.message;
					let toastOptions = {
						message: error || "Something went wrong while fetching domain list. Please contact support.",
						type: "error"
					}
					this.$store.dispatch("addToast", toastOptions);
				})
			},
			async fetchCertificatesList() {
				await this.fetchCertificates().then((response) => {
					this.certificates = response.data
				}).catch(err => {
					console.error(err)
				})
			}
		}		
	};
</script>

<style></style>
